// EHR names match those defined in app/models/smart_on_fhir.rb
export const ATHENA = "athenaOne"
export const CERNER = "Cerner"
export const CREDIBLE = "Credible"
export const EPIC = "Epic"
export const MEDITECH = "Meditech"
export const NEXT_GEN = "NextGen"
